import { isMerchantId } from "~~/shared/utils/merchant.utils";

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (
    to.path.includes("/store") ||
    to.path.includes("/market") ||
    to.path.includes("/craft")
  ) {
    const appStateStore = useAppStateStore();
    const merchant = to.params.merchant as string;
    while (!appStateStore.isAppStateLoaded) {
      await new Promise((resolve) => setTimeout(resolve, 50));
    }

    if (!isMerchantId(merchant)) {
      throw createError({
        statusCode: 404,
        statusMessage: "Merchant not found",
      });
    }

    const hasLoadedMerchants = appStateStore.merchants.length > 0;
    if (hasLoadedMerchants && !appStateStore.isMerchantActive(merchant)) {
      throw createError({
        statusCode: 404,
        statusMessage: "Merchant not found",
      });
    }

    appStateStore.currentMerchant = merchant;
    return;
  }
});
